import { skipToken } from '@tanstack/react-query';
import { getConfirmedScraps } from '../../../shared/utils/scrapUtils.ts';
import { Batch, Operation } from '../../types/sharedTypeImpl.ts';
import { formatDatetime } from '../../utils/fieldFormats.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    batch: Batch;
    toolOperations: Operation[];
}

export function BrokenToolOperations({
    batch,
    toolOperations
}: Props) {
    const operationsSorted = [...toolOperations].sort((a, b) => +b.effectiveTime - +a.effectiveTime);

    const { data: partCounts } = trpc.batches.getPartsCountsAtTimes.useQuery(
        operationsSorted ? {
            batch,
            times: operationsSorted.map(operation => operation.effectiveTime)
        } : skipToken
    );


    const isUnscheduledToolChange = (operation: Operation) => {
        return operation.operationType === 'Tool change' && operation.isScheduled === 'Not scheduled';
    }

    const isToolChangeFix = (operation: Operation) => {
        return operation.operationType === 'Fix unscheduled tool change';
    }

    return (
        <table className='table--mid-width' style={{ marginTop: '16px' }} >
            <thead>
                <tr>
                    <th>Comment</th>
                    <th>Potential scraps</th>
                    <th>Confirmed scraps</th>
                    <th style={{ minWidth: '160px' }}>Date/time</th>
                    <th>Operator</th>
                    <th>Parts produced</th>
                    <th>Collateral tools</th>
                    <th style={{ minWidth: '120px' }} />
                </tr>
            </thead>
            <tbody>
                {operationsSorted?.map((operation, idx) => {
                    const prevPartCount = partCounts?.[idx + 1];
                    const partCount = partCounts?.[idx];
                    const partsProduced = (partCount != null ? partCount - (prevPartCount ?? 0) : null);

                    const potentialScrap = operation.potentialScraps || '';// Do not show 0;
                    const isPotentialScrapHandled = operation.scrapCloseForm != null;
                    const potentialScrapClass = isPotentialScrapHandled ? 'handled-potential-scrap' : '';
                    const confirmedScraps = getConfirmedScraps(operation) || '';// Do not show 0;

                    return (
                        <tr key={operation._id}>
                            <td>{operation.comment}</td>
                            <td className={potentialScrapClass}>{potentialScrap}</td>
                            <td>{confirmedScraps}</td>
                            <td>{formatDatetime(operation.effectiveTime)}</td>
                            <td>{operation.operator}</td>
                            <td>{partsProduced ?? '...'}</td>
                            <td>{operation.collateralDamage?.length ?? null}</td>
                            <td>{isUnscheduledToolChange(operation) ? 'Not scheduled'
                                : isToolChangeFix(operation) ? 'Fix'
                                    : null
                            }</td>
                        </tr>
                    );
                })}
            </tbody>
        </table >
    );
}
